// @ts-nocheck
import React, { Component } from 'react';
import _ from 'lodash';
import { inject, observer } from "../../../../stores/mobx-compat";

import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import Modal, { ModalActions } from '../../../ui/Modal';
import FormGroup from '../../../ui/FormGroup';
import Input from '../../../ui/Input';
import Select from '../../../ui/Select';
import Empty from '../../../ui/Empty';
import { PlusIcon, MailIcon } from '../../../ui/icons';
import { modalTypes } from '../../../../enums';
import { validateEmail } from '../../../../helper';

class StopList extends Component {
  state = {
    modalOpen: false,
    modalType: modalTypes.add,
    deleteKey: null,
    hookObj: {
      emailDomain: this.props.store.emailManagement.activeEmailDomainName,
      email: '',
    },
  }

  componentDidMount() {
    const em = this.props.store.emailManagement;
    if (_.isEmpty(em.emailDomains)) em.getEmailDomains();
  }

  get domainOptions() {
    return _.map(this.props.store.emailManagement.emailDomains, (_v, domain) => domain);
  }

  closeModal = () => this.setState({
    modalOpen: false,
    hookObj: {
      emailDomain: this.props.store.emailManagement.activeEmailDomainName,
      email: '',
    },
  });

  validateForm = () => {
    if (!validateEmail(this.state.hookObj.email)) {
      this.props.store.failure('Invalid email entered.');
      return false;
    }
    return true;
  }

  setDomain = (e) => {
    this.props.store.emailManagement.setActiveEmailDomainName(null, { value: e.target.value });
  };

  render() {
    const { activeEmailDomainName } = this.props.store.emailManagement;
    const domains = this.domainOptions;
    const { hooks } = this.props.store.clientHooks;
    const reachedLimit = Object.keys(hooks).length >= 5;

    return (
      <>
        <Card className="mb-5">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div>
              <h3 className="m-0 text-[14.5px] font-semibold">Unsubscribe list</h3>
              <p className="m-0 mt-1 text-[13px] text-mov-ink-soft">
                Emails on this list will not receive remarket messages.
              </p>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {domains.length > 0 && (
                <Select
                  value={activeEmailDomainName || ''}
                  onChange={this.setDomain}
                  style={{ minWidth: 200 }}
                >
                  {domains.map((d) => <option key={d} value={d}>{d}</option>)}
                </Select>
              )}
              <Button
                variant="primary"
                icon={PlusIcon}
                disabled={reachedLimit}
                onClick={() => this.setState({
                  modalOpen: true,
                  modalType: modalTypes.add,
                  hookObj: { emailDomain: activeEmailDomainName, email: '' },
                })}
              >
                Add email
              </Button>
            </div>
          </div>
        </Card>

        {domains.length === 0 && (
          <Empty
            icon={MailIcon}
            title="No email domains set up"
            sub="Add an email domain in Recover settings before managing your stop list."
          />
        )}

        <Modal
          open={this.state.modalOpen}
          onClose={this.closeModal}
          title={this.state.modalType === modalTypes.add ? 'Add email to stop list' : 'Delete this entry?'}
          icon={this.state.modalType === modalTypes.add ? PlusIcon : MailIcon}
          actions={(
            <ModalActions
              onCancel={this.closeModal}
              onConfirm={() => {
                if (this.state.modalType === modalTypes.add) {
                  if (this.validateForm()) {
                    this.props.store.emailSuppression.addEmail(this.state.hookObj);
                    this.closeModal();
                  }
                } else {
                  this.props.store.emailSuppression.deleteEmail(this.state.deleteKey);
                  this.closeModal();
                }
              }}
              confirmLabel={this.state.modalType === modalTypes.add ? 'Add' : 'Delete'}
              confirmVariant={this.state.modalType === modalTypes.add ? 'primary' : 'danger'}
            />
          )}
        >
          {this.state.modalType === modalTypes.add && (
            <FormGroup label="Email address">
              <Input
                value={this.state.hookObj.email}
                placeholder="user@example.com"
                onChange={(e) => this.setState({ hookObj: { ...this.state.hookObj, email: e.target.value } })}
              />
            </FormGroup>
          )}
        </Modal>
      </>
    );
  }
}

export default inject('store')(observer(StopList));
